































































import Vue from 'vue'
import HeaderSection from '@/search/components/HeaderSection.vue'
import FilterItem from '@/search/components/FilterItem.vue'
import { SearchFacets, SearchFacetValues } from '@/search/types'
import { FACET_QUERY_PREFIX, FACET_TYPE } from '@/search/const'
import orderBy from 'lodash/orderBy'

export default Vue.extend({
  components: {
    HeaderSection,
    FilterItem
  },
  props: {
    searchFacets: {
      type: Array as () => SearchFacets[],
      required: true
    },
    facetValues: {
      type: Array as () => string[],
      required: true
    },
    open: {
      type: Boolean,
      default: true
    }
  },
  data(): {
    toggleSection: number[]
    facetValueNames: string[]
    linkCanonical: string[]
    openHeader: boolean
  } {
    return {
      toggleSection: [],
      facetValueNames: [],
      linkCanonical: [],
      openHeader: this.open
    }
  },
  computed: {
    routeQuery(): { [key: string]: string } {
      return this.$route.query as { [key: string]: string }
    },
    facetType(): {[key: string]: string} {
      return FACET_TYPE
    }
  },
  watch: {
    facetValues: {
      immediate: true,
      handler(value: string[]) {
        this.facetValueNames = value
      }
    }
  },
  methods: {
    sortFacetValues(
      facetValuesArray: SearchFacetValues[]
    ) {
      return orderBy(facetValuesArray, 'facetValueDisplayOrder', 'asc')
    },
    canonicalLink(facetKey: string, facetVal: string): string {
      return `/search?${FACET_QUERY_PREFIX + facetKey}=${facetVal}`
    },
    showFacetOptions(facetKeyId: string): boolean {
      const open = !this.toggleSection.includes(Number(facetKeyId))
      return this.searchFacets.length === 1 ? open && this.openHeader : open
    },
    searchFacetValues(event) {
      event.preventDefault()
      event.stopPropagation()
      this.$emit('onSearchFacet', this.facetValueNames)
    },
    toggleSectionHandler(value: { toggle: boolean; id: string }) {
      const facetId = Number(value.id)
      if (value.toggle) {
        this.toggleSection.splice(this.toggleSection.indexOf(facetId), 1)
      } else {
        this.toggleSection.push(facetId)
      }
      this.openHeader = value.toggle
      this.$emit('toggleSection', value.toggle)
    }
  }
})
